import { gql, TypedDocumentNode } from "@apollo/client";

import { SEARCH_SUGGESTIONS_FRAGMENT } from "constants/suggestions";
import {
  QueryScanRunArgs,
  ScanResourceConnection,
  SearchInput,
  SearchScanResourcesOutput,
  SearchSuggestionsInput,
  SearchSuggestionsOutput,
} from "types/generated";

import { ScanResourcesNode } from "../types";

type SearchScanResourcesData = {
  scanRun: {
    searchResources: {
      edges: Array<Pick<ScanResourceConnection, "cursor"> & { node: ScanResourcesNode }>;
      pageInfo: SearchScanResourcesOutput["pageInfo"];
    };
  };
};

type SearchScanResourcesVariables = QueryScanRunArgs & {
  input: SearchInput;
};

export const SEARCH_SCAN_RESOURCES: TypedDocumentNode<
  SearchScanResourcesData,
  SearchScanResourcesVariables
> = gql`
  query SearchScanResources($id: ID!, $input: SearchInput!) {
    scanRun(id: $id) {
      id
      searchResources(input: $input) {
        edges {
          cursor
          node {
            id
            name
            type
            identity
            isManaged
          }
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`;

type SearchScanResourcesSuggestionsData = {
  scanRun: {
    searchResourcesSuggestions: Pick<SearchSuggestionsOutput, "fields" | "filteredCount">;
  };
};

type SearchScanResourcesSuggestionsVariables = QueryScanRunArgs & {
  input: SearchSuggestionsInput;
};

export const SEARCH_SCAN_RESOURCES_SUGGESTIONS: TypedDocumentNode<
  SearchScanResourcesSuggestionsData,
  SearchScanResourcesSuggestionsVariables
> = gql`
  query SearchScanResourcesSuggestions($id: ID!, $input: SearchSuggestionsInput!) {
    scanRun(id: $id) {
      id
      searchResourcesSuggestions(input: $input) {
        ...SearchSuggestionsFragment
      }
    }
  }
  ${SEARCH_SUGGESTIONS_FRAGMENT}
`;
